<template>
  <div class="notification-badge">
    <div class="count" role="status">{{ count }}</div>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      default: 0,
      required: false,
    }
  }
}
</script>
